module.exports = __webpack_public_path__ + "img/album14_37.2b98eb87.jpg";